import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { MARKETING_CONFIG, trackPageView } from '@/lib/marketing';

export default function MarketingScripts() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    trackPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    // Google Analytics
    if (MARKETING_CONFIG.googleAnalytics.enabled && MARKETING_CONFIG.googleAnalytics.measurementId) {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${MARKETING_CONFIG.googleAnalytics.measurementId}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${MARKETING_CONFIG.googleAnalytics.measurementId}');
      `;
      document.head.appendChild(script2);
    }

    // Google Ads
    if (MARKETING_CONFIG.googleAds.enabled && MARKETING_CONFIG.googleAds.conversionId) {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${MARKETING_CONFIG.googleAds.conversionId}`;
      document.head.appendChild(script);

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${MARKETING_CONFIG.googleAds.conversionId}');
      `;
      document.head.appendChild(inlineScript);
    }

    // Facebook Pixel
    if (MARKETING_CONFIG.facebookPixel.enabled && MARKETING_CONFIG.facebookPixel.pixelId) {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${MARKETING_CONFIG.facebookPixel.pixelId}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);

      // Add noscript fallback
      const noscript = document.createElement('noscript');
      noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${MARKETING_CONFIG.facebookPixel.pixelId}&ev=PageView&noscript=1"/>`;
      document.body.appendChild(noscript);
    }

    // LinkedIn Insight Tag
    if (MARKETING_CONFIG.linkedIn.enabled && MARKETING_CONFIG.linkedIn.partnerId) {
      window._linkedin_partner_id = MARKETING_CONFIG.linkedIn.partnerId;
      const script = document.createElement('script');
      script.innerHTML = `
        (function(l) {
          if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q=[]}
          var s = document.getElementsByTagName("script")[0];
          var b = document.createElement("script");
          b.type = "text/javascript";b.async = true;
          b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b, s);})(window.lintrk);
      `;
      document.head.appendChild(script);
    }

    // Twitter Pixel
    if (MARKETING_CONFIG.twitter.enabled && MARKETING_CONFIG.twitter.pixelId) {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
        },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
        a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
        twq('config','${MARKETING_CONFIG.twitter.pixelId}');
      `;
      document.head.appendChild(script);
    }
  }, []);

  return null;
}




